var _style;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPassword(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_x32_",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      width: 48,
      height: 48,
      opacity: 1
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#4B4B4B;}\r\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M509.217,148.087c-5.531-28.661-19.512-56.207-41.673-78.34c-14.752-14.752-31.924-25.923-50.213-33.34 c-27.446-11.126-57.368-13.891-86.046-8.333c-28.662,5.531-56.207,19.513-78.349,41.673 c-14.762,14.752-25.923,31.925-33.332,50.204c-11.125,27.456-13.89,57.367-8.341,86.056c4.108,21.253,12.866,41.872,26.15,60.142 l-82.583,82.592l-38.327-38.326l-27.59,27.592l38.326,38.317L96.582,406.99l-56.723-56.724L0,390.125l96.582,96.582l181.85-181.859 c7.915,5.069,16.194,9.376,24.726,12.83c27.446,11.134,57.358,13.9,86.038,8.351c28.67-5.539,56.216-19.521,78.348-41.672 c14.762-14.762,25.923-31.935,33.34-50.223C512.01,206.688,514.776,176.775,509.217,148.087z M449.629,194.465 c-3.364,17.246-11.606,33.558-25.008,46.968c-8.94,8.949-19.159,15.559-30.094,20.002c-16.402,6.655-34.473,8.333-51.701,4.996 c-17.246-3.354-33.549-11.597-46.968-24.998c-8.949-8.95-15.559-19.159-20.002-30.103c-6.663-16.402-8.341-34.464-5.004-51.692 c3.364-17.255,11.606-33.557,25.007-46.967c8.949-8.95,19.168-15.559,30.103-20.002c16.402-6.664,34.464-8.342,51.701-5.005 c17.246,3.364,33.548,11.606,46.958,25.007c8.95,8.939,15.569,19.158,20.002,30.102 C451.279,159.168,452.965,177.229,449.629,194.465z",
    style: {
      fill: "rgb(17, 104, 173)"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPassword);
export default __webpack_public_path__ + "static/media/Password.784b0bd25059cd55aa99ed883520ff5a.svg";
export { ForwardRef as ReactComponent };